import { createTheme } from "@mui/material";
import { esES } from "@mui/material/locale";

export const themeMui = createTheme(
  {
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      }
    },
    palette: {
      primary: {
        light: "#29B6F6",
        main: "#539aff",
        dark: "#70b818",
        backgroundListItem: "#858a93",
        contrastText: "#FFFFFF",
      },
      secondary: {
        light: "#66BB6A",
        main: "#96d43a",
        dark: "#70b818",
        backgroundListItem: "#858a93",
        contrastText: "#FFFFFF",
      },
      success: { main: "#43a047" },
      error: { main: "#d32f2f" },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          "*::-webkit-scrollbar": {
            width: "0.5em",
            height: "0.5em",
          },
          "*::-webkit-scrollbar-track": {
            backgroundColor: "lightgray",
            borderRadius: "7px",
            boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
          },
          "*::-webkit-scrollbar-thumb": {
            backgroundColor: "#a3c5f4 ",
            borderRadius: "7px ",
            outline: "1px solid slategrey ",
            border: "none ",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: "4px 2px 4px 2px",
          },
        },
      },
    },
  },
  esES,
);
